module.exports = __webpack_public_path__ + "static/media/iconScroll.022a884c.svg";